import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface BaseStationHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

export const BaseStationHoverLabels = ({
  form,
}: BaseStationHoverLabelsProps) => {
  const { messages } = useLocalization();

  const BASESTATION_HOVER_FIELDS = [
    { name: 'basestation_mmsi', label: messages.settingsMapBaseStationHoverMmsiLabel, description: messages.settingsMapBaseStationHoverMmsiDescription },
    { name: 'basestation_country', label: messages.settingsMapBaseStationHoverCountryLabel, description: messages.settingsMapBaseStationHoverCountryDescription },
    { name: 'basestation_latitude', label: messages.settingsMapBaseStationHoverLatitudeLabel, description: messages.settingsMapBaseStationHoverLatitudeDescription },
    { name: 'basestation_longitude', label: messages.settingsMapBaseStationHoverLongitudeLabel, description: messages.settingsMapBaseStationHoverLongitudeDescription },
    { name: 'basestation_vdlLoad', label: messages.settingsMapBaseStationHoverVdlLoadLabel, description: messages.settingsMapBaseStationHoverVdlLoadDescription },
  ] as const;

  return (
    <div className="grid grid-cols-2 gap-4">
      {BASESTATION_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
